// extracted by mini-css-extract-plugin
export var left = "statistics-module--left--c652d";
export var stat = "statistics-module--stat--f6cbf";
export var stat_col = "statistics-module--stat_col--25e9c";
export var statistics = "statistics-module--statistics--04c01";
export var videoouter = "statistics-module--videoouter--44ada";